<template>
  <div>
    <my-header
      :page_name="$t('navigation.headerTitles.running')"
      show_usermenu
    ></my-header>
    <status-grid
      :gridData="getRunningTaskData"
      gridType="running"
      @refresh="sendForData"
    ></status-grid>
  </div>
</template>

<script>
import StatusGrid from "../../components/tasks/StatusGrid";
import Header from "../../components/reusable/header/Header";
import { mapGetters } from "vuex";
export default {
  methods: {
    sendForData() {
      this.$store.commit("setLoading", true);
      this.$store
        .dispatch("getQueueTasks", 1)
        .then((result) => {
          if (result.length === 0) this.$store.commit("setLoading", false);
        })
        .catch(() => {
          this.$store.commit("setLoading", false);
        });
    },
  },
  created() {
    this.sendForData();
  },
  computed: {
    ...mapGetters(["getRunningTaskData"]),
  },
  components: {
    myHeader: Header,
    StatusGrid,
  },
};
</script>